import { graphql } from "gatsby"

import { Button, Box, Container, Text, BlockContent } from "@mode/components"
import Image from 'gatsby-plugin-sanity-image'

export const InterstitialTwoColumnCta = ({ eyebrow, heading, _rawBody, buttons, image, formattingOptions }) => {
  return (
    <Box css={{ background: formattingOptions?.background ?? "transparent" }}>
      <Container
        css={{
          position: "relative",
          paddingTop: formattingOptions?.paddingTop ?? "$sm",
          paddingBottom: formattingOptions?.paddingBottom ?? "$sm",
          "@md": {
            paddingTop: formattingOptions?.paddingTop ?? "$md",
            paddingBottom: formattingOptions?.paddingBottom ?? "$md",
          },
        }}
      >
        <Box css={{ background: '$g4', borderRadius: '$16', padding: '$xxs', display: 'flex', flexWrap: 'wrap', flexDirection:'column-reverse', alignItems: 'center', color: '$g1', '@md': { flexDirection:'row', padding: '$sm' } }}>
          <Box css={{ width: '100%', '@md': { width: '40%' } }}>
            {image && <Image {...image} alt={image.alt ?? ""} />}
          </Box>
          <Box css={{ width: '100%', '@md': { width: '60%', paddingLeft: '$sm' } }}>
            <Box css={{ maxWidth: '450px', width: '100%', paddingTop: '$xxxxs', paddingBottom: '$sm', '@md': { width: 'auto', py: 0 } }}>
              <Text textStyle="eyebrow" as="p" color="$g2" css={{ pb: '$xxxxs' }}>{eyebrow}</Text>
              <Text textStyle="h2" as="h2">{heading}</Text>
              <BlockContent value={_rawBody} />
                <Box css={{paddingTop: '$xs'}}>
                {buttons && buttons.map((button, index) => {
                  return (
                    <Button
                      as={button.calendly ? "button" : "link"}
                      key={button._key}
                      variant={button.type}
                      to={button.url}
                      calendly={button.calendly}
                      calendlyUrl={button.calendlyUrl}
                      css={{ ml: index === 0 ? 0 : '$xxxs' }}
                      dark
                    >
                      {button.label}
                    </Button>
                  )
                })}
                </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export const query = graphql`
  fragment InterstitialTwoColumnCtaContent on InterstitialTwoColumnCta {
    _key
    image {
      ...ImageWithPreview
    }
    eyebrow
    heading
    buttons {
      ...ButtonContent
    }
    ... on SanityInterstitialTwoColumnCta {
      _rawBody(resolveReferences: { maxDepth: 5 })
    }
    formattingOptions {
      ...FormattingOptionsContent
    }
  }
`